/* eslint-disable no-unused-vars */
// Utilities
const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
};

const getFocusableElements = (container = document) => {
  return Array.from(
    container.querySelectorAll(
      `summary, a[href], button:enabled,
      [tabindex]:not([tabindex^='-']), [draggable], area,
      input:not([type=hidden]):enabled, select:enabled,
      textarea:enabled, object, iframe`,
    ),
  );
};


const animationConfig = (duration = 'regular') => {
  return {
    duration: parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        `--animation-${duration}-duration`,
      ),
    ),
    easing: 'ease',
  };
};

const createCookie = (cookieName, cookieValue, daysToExpire) => {
  const date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie = `${cookieName}=${cookieValue}; expires=${date.toGMTString()}`;
};

function getCookie (name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const setAllToMaxHeight = (className) => {
  var elements = document.querySelectorAll(className);
  var arrayLength = elements.length;
  var heights = [];

  for (var i = 0; i < arrayLength; i++) {
    heights.push(elements[i].offsetHeight);
  }

  function getHighest() {
    return Math.max(...heights);
  }

  var tallest = getHighest();

  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = tallest + 'px';
  }
};

const pauseAllMedia = () => {
  document.querySelectorAll('.youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
};

const affiliationCookie = () => {
  if (window.location.search) {
    //?affiliation=kwanko&utm_source=kwanko

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const queryUtmSource = urlParams.get('utm_source');
    const queryAffiliation = urlParams.get('affiliation');

    if (queryUtmSource && queryAffiliation) {
      var affiliationCookie = getCookie('affiliationUTM');
      if (localStorage.getItem('affiliationUTM')) {
        localStorage.removeItem('affiliationUTM');
      }
      if (affiliationCookie) {
        var affiliations = affiliationCookie + '_' + queryAffiliation;
        createCookie("affiliationUTM", affiliations, 395);
        localStorage.setItem('affiliationUTM', affiliations);
      } else {
        createCookie("affiliationUTM", queryAffiliation, 395);
        localStorage.setItem('affiliationUTM', queryAffiliation);
      }
    }
  }
};
affiliationCookie();

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.preview = this.querySelector('[id^="DeferredPreview-"]');
    if (!this.preview) return;
    const parentImageZoom = this.preview.closest('a.image-zoom');
    if (parentImageZoom === null || parentImageZoom === undefined) {
      this.preview.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('[data-popup-media]'),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
      options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
              'To add a new item both properties: ID & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
              'To update an existing item, both properties: KEY & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
        nextRequest.formData,
        nextRequest.action,
        nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
        `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then(function (cart) {
        try {
          options.onSuccess();
        } catch (e) {
          console.error(
            'Error executing onSuccess callback from postShopify',
            e,
          );
        }

        return {cart};
      })
      .catch(function (error) {
        self.handleErrors(error);

        try {
          options.onFailure();
        } catch (e) {
          console.error(
            'Error executing onFailure callback from postShopify',
            e,
          );
        }

        return {err: error};
      })
      .finally(function () {
        try {
          options.always();
        } catch (e) {
          console.error('Error executing always callback from postShopify', e);
        }

        // Handle next request if there are any in the queue.
        if (self.requestsQueue.length) {
          const nextRequest = self.requestsQueue.pop();
          return self.postShopify(nextRequest.formData, nextRequest.action);
        }
      });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

customElements.define(
  'cart-remove-button',
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.removeEvent = new Event('remove', {bubbles: true});
      this.addEventListener('click', (event) => {
        event.preventDefault();

        var productDatalayer = JSON.parse(this.getAttribute("data-product-datalayer"));

        var dataEvent = {
          "item_name": productDatalayer.item_name,
          "item_id": productDatalayer.item_id,
          "price": productDatalayer.price,
          "item_size": productDatalayer.item_size,
          "item_category": productDatalayer.item_category,
          "item_variant": productDatalayer.item_variant,
          "quantity": productDatalayer.quantity,
        };
        
        var evt = new CustomEvent("gtmRemoveToCart", {'detail': dataEvent});
        window.dispatchEvent(evt);

        this.dispatchEvent(this.removeEvent);
      });
    }
  },
);

customElements.define(
  'cart-items',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        variantSelects: 'variant-selectors',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.variantSelects = document.querySelectorAll(
        this.selectors.variantSelects,
      );

      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0,
      );

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.addEventListener('remove', (event) => {
        this.updateQuantity(
          event.target.dataset.index,
          0,
          document.activeElement.getAttribute('name'),
        );
      });
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name'),
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '.cart-drawer_footer',
        },
        {
          id: 'drawer-cart-upsell',
          section:
            document.getElementById('drawer-cart-upsell') != null
              ? document.getElementById('drawer-cart-upsell').dataset.id
              : null,
          selector: '.cart-drawer-upsell-vertical [data-upsell-cart-drawer]',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer') != null
                    ? document.getElementById('main-cart-footer').dataset.id
                    : null,
          selector: '.main-cart__footer',
        }
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch('/cart/change', {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          
          //
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter)
            cartFooter.classList.toggle(
              'is-empty',
              parsedState.item_count === 0,
            );

          this.cartNotifications.forEach((section) => {
            section.updateItemsCount(parsedState.item_count);
          });

          // if (this.variantSelects.length > 0) {
          //   this.variantSelects.forEach((section) => {
          //     section.reset();
          //   });
          // }

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                if (section.id == "main-cart-footer" && document.querySelector('body').classList.contains('template-cart')) {
                } else {
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector,
                  );
                }
              }
            }
          });

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`))
            lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading(line);
          this.updateAlmaWidget();
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) =>
            overlay.classList.add('u-hide'),
          );
          this.disableLoading(line);
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
        (overlay) => overlay.classList.remove('u-hide'),
      );
      this.querySelector(`#CartItem-${line}`).classList.add('updating');
      document.activeElement.blur();
    }

    disableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.remove('cart__items--disabled');
      this.querySelector(`#CartItem-${line}`).classList.remove('updating');
    }

    updateAlmaWidget() {
      if (document.getElementById('alma-badge')) {
        var price = parseFloat(document.getElementById('alma-badge').getAttribute('data-price'));
  
        var widgets = Alma.Widgets.initialize(
          '11uPQCS3K7pRhmcMZ7AzjcokeF8Es4hy7B', // your marchant ID, not API Key 
          Alma.ApiMode.LIVE, // API mode (LIVE or TEST)
        );
        
        widgets.add(Alma.Widgets.PaymentPlans, {
            container: '#alma-badge',
            purchaseAmount: price,
            transitionDelay:5500, // Amount of time in between button animations in ms.
            hideIfNotEligible:false, 
            locale: Shopify.locale, // Widget language. You can use fr|en|es|it|de|nl-NL|nl-BE or {{ request.locale.iso_code }} to adapt the language to the client
        })
      }
    }
  },
);

customElements.define(
  'quantity-input',
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', {bubbles: true});

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this)),
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus'
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  },
);

customElements.define(
  'cart-notification',
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartCount: '[data-cart-count]',
      };
      this.selectors = selectors;
      this.cartNotification = this.querySelector(this.selectors.cartCount);
    }

    updateItemsCount(itemsCount) {
      if (!this.cartNotification) return;

      this.cartNotification.innerHTML = itemsCount;
    }
  },
);

customElements.define(
  'cart-drawer',
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartOpen: '[data-cart-drawer-open]',
        cartClose: '[data-cart-drawer-close]',
        cartDrawer: 'cart-drawer-v2',
        cartOverlay: 'cart-overlay',
        cartNotification: 'cart-notification',
      };

      this.selectors = selectors;
      this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
      this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );

      this.cartDrawer.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close(),
      );

      document
        .querySelectorAll(this.selectors.cartOpen)
        .forEach((cartOpen) =>
          cartOpen.addEventListener('click', this.handleCartUpdates.bind(this), false),
        );

      this.init();
    }

    init() {
      // Detect cart interactions
      this.httpInterceptor(
        [
          '/cart/add',
          '/cart/add',
          '/cart/change',
          // '/cart/update',
          '/cart/clear',
        ],
        this.handleCartUpdates.bind(this),
      );
    }

    open() {
      this.cartDrawer.classList.add('animate', 'active');
      this.cartOverlay.classList.add('animate', 'active');

      this.openStatus = false;

      document.body.style.overflow = 'hidden';
    }

    close() {
           
      this.cartDrawer.classList.remove('active');
      this.cartOverlay.classList.remove('active');

      this.closeStatus = false;

      document.body.style.overflow = 'auto';
    }

    async renderContents() {
      await fetch('/?sections=cart-drawer-v2', {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {
          const doc = new DOMParser().parseFromString(
            response['cart-drawer-v2'],
            'text/html',
          );
          var contentUpdated = doc.querySelector('#cart-drawer-v2').innerHTML;
          this.cartDrawer.innerHTML = contentUpdated;

          document
            .querySelectorAll(this.selectors.cartClose)
            .forEach((cartClose) =>
              cartClose.addEventListener('click', this.close.bind(this)),
            );
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      this.open();
    }

    async handleCartUpdates(res, url) {
      if (res != undefined && res.target != undefined && res.target) {
        res.preventDefault();
      }
      const shopifyCart = await cartManager.getCart();
      this.cartNotifications.forEach(cartNotification => {
        if (typeof cartNotification.updateItemsCount === 'function') {
          cartNotification.updateItemsCount(shopifyCart.item_count);
        }
      });
      let refreshContents = true;

      if (localStorage.getItem('noteUpdated')) {
        localStorage.removeItem('noteUpdated');
        refreshContents = false;
      }

      if (refreshContents) {
        await this.renderContents();
      }
    }

    async httpInterceptor(urlmatchs, callback) {
      var responseMatchesAnyUrl = function (requestUrl, urls) {
        if (!Array.isArray(urls)) urls = [urls];

        for (const url of urls) {
          if (!requestUrl.includes(url)) continue;
          return true;
        }

        return false;
      };

      // Intercept fetch.
      const constantMock = window.fetch;
      window.fetch = function () {
        return new Promise((resolve, reject) => {
          constantMock
            .apply(this, arguments)
            .then(async (response) => {
              try {
                if (
                  responseMatchesAnyUrl(response.url, urlmatchs) &&
                  response.type != 'cors' &&
                  response.ok
                ) {
                  let json = await response.clone().json();
                  if (typeof callback === 'function')
                    await callback(json, response.url);
                }
              } catch (err) {
                console.error(
                  'Something went wrong while intercepting cart update',
                  err,
                );
              }
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      };

      // Intercept Ajax.
      let send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener(
          'readystatechange',
          async function () {
            if (
              responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
              this.readyState === 4 &&
              this.status == 200
            ) {
              if (typeof callback === 'function')
                await callback(JSON.parse(this.response), this.responseURL);
            }
          },
          false,
        );
        send.apply(this, arguments);
      };

      // TODO: Listen to HTML form submits.
      // Intercept HTML Forms.
      document.addEventListener(
        'submit',
        function (e) {
          // Valid the target.
          if (
            !e.target ||
            e.target.tagName.toLowerCase() !== 'form' ||
            e.target.matches('[sz-no-block]')
          )
            return;
          // Validate the URL.
          var form = e.target;
          var submitButton = e.submitter;
          if (submitButton == null) {
            var submitButton = e.target.querySelector('button[type="submit"]')
          }
          
          var actionUrl = new URL(form.action);
          var actionPath = actionUrl.pathname;
          if (!actionPath.includes('/cart')) return;

          var productDatalayer = JSON.parse(submitButton.getAttribute("data-product-datalayer"));

          var dataEvent = {
            "item_name": productDatalayer.item_name,
            "item_id": productDatalayer.item_id,
            "price": productDatalayer.price,
            "item_size": productDatalayer.item_size,
            "item_category": productDatalayer.item_category,
            "item_variant": productDatalayer.item_variant,
            "quantity": productDatalayer.quantity,
          };
          
          var evt = new CustomEvent("gtmAddToCart", {'detail': dataEvent});
          window.dispatchEvent(evt);

          e.preventDefault();
          this.cartDrawer = document.querySelector('cart-drawer');

          if (submitButton.getAttribute("data-bundle-submit-v2") != null) {

            var items = [];
            var variant_id_parent = document.querySelector('.product_form-wrap').dataset.bundleVariant;
            var bundle_items_length = document.querySelectorAll("[data-bundle-variant]").length - 1;
            var bundle_items_id = Date.now();
            var bundle_discount = 0;
            if (document.querySelector('[data-bundle-discount]').dataset.bundleDiscount) {
              bundle_discount = parseInt(document.querySelector('[data-bundle-discount]').dataset.bundleDiscount);
            }

            let inputBundleProductId = document.querySelector('.product_form-wrap input[name="product-id"]');
            let bundleProductTag = 'PACK_';
            if (inputBundleProductId !== null && inputBundleProductId !== undefined) {
              bundleProductTag = bundleProductTag + inputBundleProductId.value;
            }
            bundleProductTag = bundleProductTag + '_1_';
            let bundlePriceElement = document.querySelector('[data-price-bundle]');
            if (bundlePriceElement !== null && bundlePriceElement !== undefined) {
              bundleProductTag = bundleProductTag + bundlePriceElement.dataset.priceBundle;
            }

            document.querySelectorAll("[data-bundle-variant]").forEach((item) => {
              if (item.dataset.bundleVariant != variant_id_parent) {
                var properties = {
                  '_is_bundle': true,
                  '_bundle_id': bundle_items_id,
                  '_bundle_length': bundle_items_length,
                  '_bundle_discount': bundle_discount,
                  '_bundle_product_tag': bundleProductTag
                }
                items.push(
                  {
                    id: item.dataset.bundleVariant,
                    quantity: 1,
                    properties: properties
                  }
                )
              }
            });

            let formData = {
              'items': items
            };
                
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(async function (response) {
              if (response.status) {
                return;
              }

              if (typeof callback === 'function')
                await callback(undefined, response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {});
            
          } else if (submitButton.getAttribute("data-upsell-submit") != null) {

            var items = [];
            var parentProductId;
            document.querySelectorAll("[data-upsell-variant]").forEach((item) => {
              var itemType = item.getAttribute("type");

              if (itemType == "checkbox") {
                parentProductId = item.dataset.upsellParent;
                
                if (item.checked) {
                  //produits enfants

                  var obj = {
                    id: item.dataset.upsellVariant,
                    quantity: 1,
                    properties: {
                      "_upsell_discount_added": parentProductId
                    }
                  };

                  if (item.dataset.upsellDiscount) {
                    obj.properties["_upsell_discount_" + item.dataset.upsellDiscount] = true;
                  }

                  if (item.dataset.clubDiscountPercent) {
                    obj.properties["_club_discount_percent"] = item.dataset.clubDiscountPercent;
                  }

                  if (item.dataset.clubDiscountedPrice) {
                    obj.properties["_club_discounted_price"] = item.dataset.clubDiscountPercent;
                  }

                  items.push(obj);
                }
                
              } 
              
            });

            if (parentProductId) {

              let parentItem = {
                id: parentProductId,
                quantity: 1,
                properties: {
                  "_upsell_discount_adder": parentProductId
                }
              };

              const inputClubDiscount = form.querySelector('[name="properties[_club_discount_percent]"]');
              if (inputClubDiscount !== null && inputClubDiscount !== undefined) {
                const inputClubDiscountValue = inputClubDiscount.value;
                if (inputClubDiscountValue !== null && inputClubDiscountValue !== undefined && inputClubDiscountValue !== "false") {
                  parentItem.properties["_club_discount_percent"] = inputClubDiscountValue;
                }
              }

              const inputClubDiscountedPrice = form.querySelector('[name="properties[_club_discounted_price]"]');
              if (inputClubDiscountedPrice !== null && inputClubDiscountedPrice !== undefined) {
                const inputClubDiscountedPriceValue = inputClubDiscountedPrice.value;
                if (inputClubDiscountedPriceValue !== null && inputClubDiscountedPriceValue !== undefined && inputClubDiscountedPriceValue !== "false") {
                  parentItem.properties["_club_discounted_price"] = inputClubDiscountedPriceValue;
                }
              }

              items.push(parentItem);
            }

            let formData = {
              'items': items
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(async function (response) {
              if (response.status) {
                return;
              }

              if (typeof callback === 'function')
                await callback(undefined, response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {});

          } else {

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
  
            const formData = new FormData(form);
            config.body = formData;
  
            fetch(actionPath, config)
              .then((response) => response.json())
              .then(async function (response) {
                if (response.status) {
                  return;
                }
  
                const submitButtonInnerHTML = submitButton.innerHTML;
                // Upsell
                if (submitButton.classList.contains('button-upsell')) {
                  submitButton.classList.add('upsell-active');
                  submitButton.classList.add('button--primary');
                  submitButton.classList.remove('button--outlined');
                  submitButton.disabled = "disabled";
                  submitButton.innerHTML = "<span class='icon icon-check'></span>";
                }

                // Upsell 2
                setTimeout(() => {

                  submitButton.classList.remove('upsell-active');
                  submitButton.classList.add('button--primary');
                  submitButton.disabled = false;
                  submitButton.innerHTML = submitButtonInnerHTML;
                  
                }, 3000);
  
                if (typeof callback === 'function')
                  await callback(undefined, response);
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {});
          }
        }.bind(this),
      );
    }
  },
);

customElements.define(
  'main-collection',
  class MainCollection extends HTMLElement {
    constructor() {
      super();

      if (
        document.querySelector('.product-card_title') != undefined &&
        document.querySelectorAll('.product-card_title').length > 0
      ) {
        setAllToMaxHeight('.product-card_title');
      }
      if (
        document.querySelector('.product-card_description') != undefined &&
        document.querySelectorAll('.product-card_description').length > 0
      ) {
        setAllToMaxHeight('.product-card_description');
      }
    }
  },
);

class DetailsAccordion extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));

    this.open = this.open.bind(this);
    this.shrink = this.shrink.bind(this);
    this.expand = this.expand.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    const config = animationConfig();
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      config,
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    const config = animationConfig();
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      config,
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

customElements.define('details-accordion', DetailsAccordion);

class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.tigger = this.querySelector('[data-trigger-modal]');
    this.content = this.querySelector('[data-content-modal]');
    this.closes = this.querySelectorAll('[data-close-modal]');

    this.tigger.addEventListener('click', (e) => {
      this.openModal(e);
      document.body.style.overflow = 'hidden';
    });
    this.closes.forEach((close) =>
      close.addEventListener('click', (e) => {
        this.closeModal(e);

        let allowRevomeBodyOverflowHidden = true;

        // Check if some sidepage are open
        const sectionClubLoginRegisterOpen = document.querySelector('[data-club-login-register].active');
        if (sectionClubLoginRegisterOpen !== null && sectionClubLoginRegisterOpen !== undefined) {
          allowRevomeBodyOverflowHidden = false;
        }

        if (allowRevomeBodyOverflowHidden) {
          document.body.style.overflow = 'auto';
        }
      })
    );
  }

  openModal(e) {
    this.content.classList.add("open");
  }

  closeModal(e) {
    this.content.classList.remove("open");
  }

}

customElements.define('modal-component', ModalComponent);


//Link obfuscation

document.querySelectorAll(".obflink").forEach((obflink) => {
  obflink.addEventListener("click", function() {
    var t = this;
    // Decode url
    var link = atob(t.dataset.o);
    window.open(link);
  });
})